import { render } from "./ProductOneClick.vue?vue&type=template&id=64a79908"
import script from "./ProductOneClick.vue?vue&type=script&lang=js"
export * from "./ProductOneClick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__